import { Target } from "./target";

export class TargetGroup {

    targetId : any;
    childTargetsExist : any;
    targets : Target[] = [];
}
